import { Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { AboutComponent } from './pages/about/about.component';
import { ContactComponent } from './pages/contact/contact.component';
import { MusicComponent } from './pages/music/music.component';
import { ShowsComponent } from './pages/shows/shows.component';
import { LoginComponent } from './pages/admin/login/login.component';
import { GalleryComponent } from './pages/gallery/gallery.component';
import { DashboardComponent } from './pages/admin/dashboard/dashboard.component';

export const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'home', component: HomeComponent, data: { title: 'Home' } },
  { path: 'about', component: AboutComponent, data: { title: 'About' } },
  { path: 'contact', component: ContactComponent, data: { title: 'Contact' } },
  { path: 'music', component: MusicComponent, data: { title: 'Music' } },
  { path: 'shows', component: ShowsComponent, data: { title: 'Shows' } },
  { path: 'gallery', component: GalleryComponent, data: { title: 'Gallery' } },
  {
    path: 'admin',
    children: [
      { path: 'login', component: LoginComponent, data: { title: 'Login' } },
      {
        path: 'dashboard',
        component: DashboardComponent,
        data: { title: 'Dashboard' },
      },
      // Add more admin routes here if needed
    ],
  },
];
